import { parseJwt } from "../../../auth";
import { logger } from "../../../datadog";
import { normalizeError } from "../../../utils";

type ZoomJwtPayload = {
  app_key: string;
  role_type: number;
  tpc: string; // room name
  version: number;
  iat: number;
  exp: number;
  user_identity: string;
  cloud_recording_option: number;
  cloud_recording_election: number;
  video_webrtc_mode: number;
  audio_webrtc_mode: number;
};

export function parseZoomToken(zoomJwt: string): ZoomJwtPayload | null {
  try {
    return parseJwt<ZoomJwtPayload>(zoomJwt);
  } catch (error) {
    logger.error("Failed to parse Zoom JWT", {}, normalizeError(error));
    return null;
  }
}
